export default __webpack_public_path__ + "770259316d5142461299a464e4ebb7a4.png";